<template>
  <div class="flex-center blocking-zero">
    <div class="flex-column-center">
      <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
      <p>{{ text }}</p>
      <slot name="resultContent" />
    </div>
  </div>
</template>

<script>
	export default {
		name: 'w-no-result',
    props: {
			text: {
				type: String,
        default: ''
      }
    },
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  .blocking-zero {
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 74px;
      height: 74px;
      object-fit: contain;
      margin-bottom: 18px;
    }
    p {
      color: $color-dark-gray
    }
  }
</style>
